class ProductBundlePicker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-bundle-quantity-input]');
    this.options = this.querySelectorAll('[data-bundle-option]');

    this.options.forEach((option) => {
      option.addEventListener('click', () => this.#select(option));
    });

    const defaultQty = this.dataset.defaultQuantity || '1';
    const defaultOption =
      this.querySelector(`[data-bundle-option][data-quantity="${defaultQty}"]`) || this.options[0];
    if (defaultOption) this.#select(defaultOption, { silent: true });
  }

  /**
   * @param {string|number} quantity
   * @param {{ silent?: boolean, priceCents?: number }} [opts]
   */
  #setQuantity(quantity, opts = {}) {
    if (this.input) this.input.value = quantity;

    document.querySelectorAll('[data-sticky-qty-shadow]').forEach((input) => {
      if (input instanceof HTMLInputElement) input.value = quantity;
    });
    document.querySelectorAll('[data-sticky-qty] input[type="number"]').forEach((input) => {
      if (input instanceof HTMLInputElement) input.value = quantity;
    });

    const priceCents = Number(opts.priceCents || 0);
    // Always notify listeners (incl. free-shipping bar) — silent only skips duplicate UI work.
    this.dispatchEvent(
      new CustomEvent('bundle-quantity-change', {
        bubbles: true,
        detail: {
          quantity: Number(quantity),
          priceCents,
          silent: Boolean(opts.silent),
        },
      })
    );
  }

  /**
   * @param {Element} option
   * @param {{ silent?: boolean }} [opts]
   */
  #select(option, opts = {}) {
    const quantity = option.dataset.quantity;
    if (!quantity) return;

    this.options.forEach((el) => {
      const selected = el === option;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    this.#setQuantity(quantity, {
      silent: opts.silent,
      priceCents: Number(option.dataset.priceCents || 0),
    });
  }
}

if (!customElements.get('product-bundle-picker')) {
  customElements.define('product-bundle-picker', ProductBundlePicker);
}
